module.exports = __webpack_public_path__ + "img/sound.6e114f77.png";